export default __webpack_public_path__ + "static/media/msgTone.5e6564f7.mp3";